import React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { DataGrid } from '@material-ui/data-grid';
import { formatDate, formatNumbers } from '@domain/utils/format.utils';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'promo', headerName: 'Promo', width: 180 },
  { field: 'grantDate', headerName: 'Grant', ...formatColWithDate, width: 150 },
  { field: 'collectDate', headerName: 'Collect', ...formatColWithDate, width: 150 },
  { field: 'coins', headerName: 'Coins', width: 150 },
  { field: 'cash', headerName: 'Cash', width: 150 },
];

interface PromosCollectData {
  promo: number;
  grantDate: string;
  collectDate: string;
  coins: number;
  cash: number;
}

let index = 0;
function createData(promosCollectData: PromosCollectData) {
  index += 1;
  return { id: index, ...promosCollectData };
}

const PromosCollects = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;
  const praia = 'BOTH';

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<PromosCollectData[]>(`/admin/promos/collects/`, { params: { pid, praia, page }, cancelToken });
  }
  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  const total = rows.length;
  return (
    <>
      <TabTableContainer>
        <Title>Promo Collects ({total})</Title>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PromosCollects;
